<template>
	<div class="coach_coachee_assignment">

		<div class="row page-heading mx-0">
			<div class="col-8 input module_heading" role="heading" aria-level="1">
	        	<span class="module_icon icon-student1"></span>
	        	<span class="module_type_name">Coach-Subscriber Assignment</span>
	      	</div>
	      	<div class="col-4 submit btn-container text-right">
	        	<button type="button" class="btn btn-primary" :disabled="!enableAssign" @click="assign" aria-label="Assign">Assign</button>
	      	</div>
	    </div>

        <b-container class="fluid user_list_container">
            <b-row>

                <div class="facets col-6 coach-list-container">
                    <div class="main_head">
                        <span class="head_txt">Coaches</span>
                        <!--
                        <span class="float-right">
                            <button type="button" class="btn btn-primary" @click="enrollUsers" aria-label="enroll" :disabled="(selectedUsers.length === 0)">enroll</button>
                        </span>
                      -->
                      <div class="search-row">
                        	<input type="text" class="input-search" placeholder="search for coaches" @input="searchCoach" aria-label="search user" v-model.trim="searchTermCoach">
                        	<div class="clear-btn" v-if="this.searchTermCoach.length > 0" @click="searchCoach">
              					<b-btn @click="searchTermCoach = ''" aria-label="clear">X</b-btn>
            				</div>
            				<!-- <button type="button" class="btn btn-primary" @click="searchUser" aria-label="go">Go</button>-->
                    	</div>
                    </div>

                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="facet_row_container">
                                <template v-if="shouldShowNoResultFound">
                                    <span class="no-result">No results found!</span>
                                </template>
                                <template v-else>
                                    <b-form-group aria-label="selected users">
                                        <b-form-radio-group plain stackechd v-model="selectedCoachUser" aria-label="selected users list">
                                            <template v-for="user in coachUserList">
                                                <b-form-radio :value="user.uuid"><span class="check-description">{{ user.firstName }} {{ user.lastName }}</span></b-form-radio>
                                            </template>
                                        </b-form-radio-group>
                                    </b-form-group>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="facets col-6 coachee-list-container">
                    <div class="main_head">
                        <span class="head_txt">Subscriber</span>

                        <div class="search-row">
	                        <input type="text" class="input-search" placeholder="search for Subscriber" @input="searchStudent" aria-label="search user" v-model.trim="searchTermStudent">
	                        <div class="clear-btn" v-if="this.searchTermStudent.length > 0" @click="searchStudent">
	              				<b-btn @click="searchTermStudent = ''" aria-label="clear">X</b-btn>
	            			</div>
	            			<!-- <button type="button" class="btn btn-primary" @click="searchUser" aria-label="go">Go</button>-->
	                    </div>
                    </div>

                    <div class="facet_block_container">
                        <div class="facet_block">
                            <div class="facet_row_container">
                                <b-form-group aria-label="selected enrolled users">
                                    <b-form-radio-group plain stacked v-model="selectedStudentUser" aria-label="selected enrolled users list">
                                        <template v-for="student in studentUserList">
                                            <b-form-radio :class="isDisabled(student.advisors)" :value="student.uuid" :disabled="student.advisors && student.advisors.length > 0"><span class="check-description">{{ student.firstName }} {{student.lastName}}</span></b-form-radio>
                                        </template>
                                    </b-form-radio-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>
        </b-container>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'coacheeAssignment',
  props: [],
  components: {
  },
  data: () => {
    return {
      pageSize: 100,
      users: [],
      coachUserList: [],
      studentUserList: [],
      selectedCoachUser: '',
      selectedStudentUser: '',
      selectedRoles: ['Admin', 'Instructor'],
      searchTermCoach: '',
      searchTermStudent: '',
      shouldShowNoResultFound: false
    }
  },

  mounted () {
    this.searchCoach()
    this.searchStudent()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadUsersForRole',
      'loadAssignCoachCoachee'
    ]),
    isDisabled (advisors) {
      if (advisors && advisors.length > 0) {
        if (this.selectedCoachUser === advisors[0]) {
          return 'green-bg'
        }
        return 'radio-disabled-input'
      }
      return ''
    },
    searchCoach () {
      this.coachUserList = []
      let roles = 'Coach'
      var searchString = $.trim(this.searchTermCoach)
      var name = (searchString.length === 0) ? undefined : searchString
      var data = {
        role: roles,
        parentSpaceId: this.currentInstitutionId,
        page: 0,
        count: this.pageSize,
        name: name
      }
      this.loadUsersForRole(data).then(res => {
        this.coachUserList = res.content
      })
    },
    searchStudent () {
      this.studentUserList = []
      let roles = 'Student'
      var searchString = $.trim(this.searchTermStudent)
      var name = (searchString.length === 0) ? undefined : searchString
      var data = {
        role: roles,
        parentSpaceId: this.currentInstitutionId,
        page: 0,
        count: this.pageSize,
        name: name
      }
      this.loadUsersForRole(data).then(res => {
        this.studentUserList = res.content
      })
    },
    assign () {
      this.loadAssignCoachCoachee({coachId: this.selectedCoachUser, coacheeId: this.selectedStudentUser}).then(res => {
        if (res) {
          this.$notify({
            group: 'notify',
            type: 'success',
            title: '',
            text: 'Successfully assigned coach!'
          })
          this.selectedCoachUser = ''
          this.selectedStudentUser = ''
          this.searchCoach()
          this.searchStudent()
        }
      })
    }
  },

  computed: {
    ...mapState({
      'stream': state => state.stream.stream
    }),
    currentInstitutionId () {
      var userObj = JSON.parse(localStorage.getItem('userobj'))
      return userObj.institutionId
    },
    enableAssign () {
      if (this.selectedCoachUser && this.selectedStudentUser) {
        return true
      }
      return false
    }
  },

  watch: {
    selectedCoachUser (newSelectedCoachUser) {
      this.searchStudent()
    }
  }
}
</script>
<style>
.radio-disabled-input{
  background: #e1e1e1!important;
}
.green-bg {
  background: #bee4e6!important;
}
</style>



// WEBPACK FOOTER //
// src/app/coacheeTracker/components/CoacheeAssignment.vue